import React, { useState } from 'react'
import { AccordionGroupCustomEvent, IonAccordion, IonAccordionGroup, IonItem, IonLabel, IonList } from '@ionic/react'
import { chevronForward } from 'ionicons/icons'
import './ChartSummaryList.content.css'

export interface IChartSummaryListItem {
  key: string
  title?: string
  subtitle?: string
  note?: React.ReactNode
  testId?: string
  renderHeader?: () => React.ReactNode
  renderContent?: () => React.ReactNode
}

interface IChartSummaryListProps {
  items: IChartSummaryListItem[]
  onSelect?: (key: string) => void
}

const ChartSummaryList: React.FC<IChartSummaryListProps> = ({ items, onSelect }) => {
  const [openKey, setOpenKey] = useState<string | null>(null)
  const isExpandable = items.length > 0 && items.every((item) => item.renderContent)

  const renderHeader = (item: IChartSummaryListItem) =>
    item.renderHeader ? (
      item.renderHeader()
    ) : (
      <IonLabel className='ion-text-wrap'>
        <h2 className='qa-addendum-chart-summary-row-title'>{item.title}</h2>
        {item.subtitle ? <h3 className='qa-addendum-chart-summary-row-subtitle'>{item.subtitle}</h3> : null}
        {item.note ? <p className='qa-addendum-chart-summary-row-note'>{item.note}</p> : null}
      </IonLabel>
    )

  if (isExpandable) {
    return (
      <IonAccordionGroup
        className='qa-addendum-chart-summary-rows'
        value={openKey ?? undefined}
        onIonChange={(event: AccordionGroupCustomEvent) => {
          if (event.target !== event.currentTarget) return
          const value = event.detail.value
          setOpenKey(typeof value === 'string' ? value : null)
        }}>
        {items.map((item) => (
          <IonAccordion
            key={item.key}
            value={item.key}
            toggleIcon={chevronForward}
            className='qa-addendum-chart-summary-accordion'>
            <IonItem slot='header' data-testid={item.testId}>
              {renderHeader(item)}
            </IonItem>
            <div slot='content' className='qa-addendum-chart-summary-row-body'>
              {openKey === item.key ? item.renderContent?.() : null}
            </div>
          </IonAccordion>
        ))}
      </IonAccordionGroup>
    )
  }

  return (
    <IonList className='qa-addendum-chart-summary-rows'>
      {items.map((item) => (
        <IonItem
          key={item.key}
          button
          detail
          detailIcon={chevronForward}
          className='qa-addendum-chart-summary-row'
          data-testid={item.testId}
          onClick={() => onSelect?.(item.key)}>
          {renderHeader(item)}
        </IonItem>
      ))}
    </IonList>
  )
}

export default ChartSummaryList
